export class EmailLinkResultDto {
    emailId: number;
    type: string;
    account: string;
    folder: string;
    sender: string;
    subject: string;
}
